import { createApp } from 'vue'
/**
 *
 * 导入i18n国际化配置
 */
import i18n from "./plugs/i18n"

/**
 *
 * 导入element ui
 */
import ElementPlus from 'element-plus'
//@ts-ignore
// import zhCn from 'elememt-plus/es/locale/lang/zh-cn'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import './element-variables.scss'
/**
 *
 * 导入Vuex
 */
import store from "@/stores";

import App from './App.vue'

/**
 * 导入路由
 */
import router from "@/router"

import VueParticles from 'vue-particles'

const app = createApp(App)

app.use(ElementPlus,{
    locale: zhCn,
    })
    .use(router)
    .use(store)
    .use(VueParticles)
    .use(i18n)
    .mount('#app')



// axios
import axios from 'axios';
// axios.defaults.baseURL = config.api_url; // 设置了主域名则接口就不需要+了
axios.defaults.withCredentials = false; // 跨域设置，false忽略跨域cookies（Access-Control-Allow-Headers:*）
axios.defaults.timeout = 16000; // 等待时间，ms

